import React, {useState} from 'react';
import './ContractProvize.css'; // Assuming you save the CSS in Contract.css
import razitko from '../../../img/razitko.png'
import Button from 'react-bootstrap/Button';
import fetchData from '../../../function/fetchData'
import SignatureColumn from './SignatureColumn';
import Spinner from 'react-bootstrap/Spinner';

const ContractProvize = ({server, token, data, tokenOfContract, alreadySigned , handleDone, setShowMessage}) => {
    const [loading, setLoading] = useState(false)
    const type = 'contractProvize'
    const serverAddress = server + "api2/contractController.php"
    const [email, setEmail] = useState("")
    const [formData, setFormData] = useState({
        employer: data ? data.employer : 'Vaněček Marek, Vítězslava Nezvala 4281, Chomutov 430 01, Ic: 09286543' ,
        employee: data ? data.employee : '',
        employeeNumber: data ? data.employeeNumber : '',
        startDate: data ? data.startDate : '',
        date: data ? data.date : '',
        commission: data ? data.commission : '15 %',
        commission2 : data ? data.commission2 : '350 Kč',
        commission3 : data ? data.commission3 : '15 %',
        commission4 : data ? data.commission4 : '15 %',
        commission5 : data ? data.commission5 : '60 Kč',
        commission6 : data ? data.commission6 : '1.95 %',
        salary: data ? data.salary : '85 %',
        });


  // Function to handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // Odeslat
  const handleSubmit = (e) => {
 
    e.preventDefault();
    // Convert formData to JSON
    const json = JSON.stringify(formData);
    
    // Pošle data
    if(json && email.length > 5){
      setLoading(true)
        fetchData(serverAddress , {
            token: token,
            action: 'SAVE',
            type: type,
            formData: formData,
            email: email
        }).then( (res) => {
          setShowMessage('Smlouva byla odeslána.')
          setLoading(false)
     
        })
    } else {
        alert('Vyplňte email')
    }
  };

  console.log(server + "api2/saveSignatureController.php")

/// Uloží podpis
const sendSignatureToServer = async (dataUrl) => {
  // Concatenate the full URL
  const serverAddress = `${server}api2/saveSignatureController.php`;
  console.log(dataUrl)
  // Send the data to the server
  try {
    const response = await fetch(serverAddress, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        action: "SAVE_SIGNATURE",
        payload: {
          tokenOfContract: tokenOfContract,
          signature: dataUrl
        }
      }),
    });

    if (!response.ok) {
      throw new Error('Network response was not ok');
    }

    const result = await response.json();
    console.log('Signature saved:', result);
    handleDone()
    setLoading(false)
  } catch (error) {
    console.error('Error:', error);
  }
};


  return (
    <div className="contract">
        <h2>Smlouva o zprostředkování zakázek aplikace a platbě řidičů</h2>
        <br />
        <div className="section">
            <p><strong>Mezi:</strong> Majitel aplikace jménem GLOBAL+ (dále jen „Majitel“)</p>
            <p>Vaněček Marek, bytem Vítězslava Nezvala II 4281, Chomutov</p>
            <p>Sídlo firmy: Na Moráni 5357, Chomutov</p>
        </div>

        <div className="section">
            <p><strong>a</strong></p>
            <br />
            <p><strong>Řidič č <input type='text' className='niceInput' style={{width: 50}} name={'employeeNumber'} value={formData.employeeNumber} onChange={handleChange} readOnly={alreadySigned ? true : false} /> (dále jen „Řidič)</strong></p>
            <input type='text' className='niceInput' style={{width: '100%'}} name={'employee'} value={formData.employee} onChange={handleChange} readOnly={alreadySigned ? true : false} />
        </div>

        <h3>Předmět smlouvy:</h3>
        <ol>
            <li>Majitel provozuje aplikaci GLOBAL+ sloužící k zprostředkování zakázek (dále jen „Aplikace“).</li>
            <li>Řidič se zavazuje přijímat zakázky prostřednictvím Aplikace a provádět přepravu a další související služby v souladu s pokyny Majitele a pravidly Aplikace.</li>
        </ol>

        <h3>Podmínky zprostředkování zakázek:</h3>
        <ol>
            <li>Řidič souhlasí s tím, že za každou uskutečněnou transakci prostřednictvím Aplikace, ať už hotově nebo kartou, Majiteli zaplatí poplatek ve výši <input type='text' className='niceInput' style={{width: 50}} name={'commission'} value={formData.commission} onChange={handleChange} readOnly={alreadySigned ? true : false} />  z celkové částky transakce.</li>
            <li>Každý poslední týden v měsíci při vyúčtování bude přičteno <input type='text' className='niceInput' style={{width: 80}} name={'commission2'} value={formData.commission2} onChange={handleChange} readOnly={alreadySigned ? true : false} /> za členství aplikace driver Global Plus, který tento poplatek náleží našemu vývojáři.</li>
        </ol>

        <h3>Podmínky platby řidičům:</h3>
        <ol>
            <li>Řidiči, kteří vyberou hotovost nebo prostřednictvím terminálu za provedené služby, jsou povinni odevzdat Majiteli <input type='text' className='niceInput' style={{width: 70}} name={'commission3'} value={formData.commission3} onChange={handleChange} readOnly={alreadySigned ? true : false} /></li>
            <li>Řidič se zavazuje odevzdat tento poplatek Majiteli jménem Vaněček Marek, společnost GLOBAL PLUS, vždy v neděli do 20:00h každého týdne, a to za zakázky, které byly provedeny v předchozím týdnu od NEDĚLE - DO – NEDĚLE OD 10 HOD DO 10HOD (denní směna), na poukázaný účet vedený u Moneta Money Bank, a.s. č.ú. 243831060 kód banky: 0600.</li>
        </ol>

        <p>Pokud bude 10% provize zaplacena do neděle každého týdne, je Majitel Vaněček Marek povinen doplatit postržení pokut či dluhu částku, kterou brigádník celkem na Terminálu vydělal. Z toho majitel odečte výběr <input type='text' className='niceInput' style={{width: 60}} name={'commission5'} value={formData.commission5} onChange={handleChange} readOnly={alreadySigned ? true : false} /> z bankomatu dle smluvních podmínek mypos a dále bude strženo celkem z celkové částky výdělku <input type='text' className='niceInput' style={{width: 80}} name={'commission6'} value={formData.commission6} onChange={handleChange} readOnly={alreadySigned ? true : false} />.</p>
        <p>Vyplácení řidičů z terminálu proběhne v hotovosti v místě firmy Na Moráni 5357, Chomutov.</p>
        <p>Vyplácení řidičům:<input type='text' style={{width: 50}} className='niceInput' name='salary' value={formData.salary} onChange={handleChange} readOnly={alreadySigned ? true : false} /> z každé úspěšně dokončené zakázky zůstává brigádníkovi viz. nahoře.</p>
        <br />
        <h3>Smluvní pokuty za zakázky:</h3>
        <ol>
            <li>Zakázka přijmuta nad 3 min = 150,-Kč</li>
            <li>Zakázka, která nebyla odjeta na čas = 200,-Kč</li>
            <li>Zakázka, kde byla poslána omluvenka (tzv. Zpozdění) = 40,-Kč</li>
            <li>Příchod do práce bez přihlášení aplikace na čas 20:00 nebo 8:00 = pokuta 400,-Kč nebo nadělat 60 minut a pokuta je neplatná</li>
            <li>MYSTERY – úspěšný 400Kč odměna, NEÚSPĚŠNÁ 600Kč pokuta</li>
        </ol>

        <h3>Platnost smlouvy:</h3>
        <p>Tato smlouva vstupuje v platnost okamžikem podpisu obou stran (dále jen Majitel a Řidič) od <input type='text' className='niceInput' style={{width: 120}} name={'startDate'} value={formData.startDate} onChange={handleChange} readOnly={alreadySigned ? true : false} /> Smlouva je uzavřena na dobu neurčitou a může být ukončena každou stranou s dodržením přiměřeného výpovědního termínu viz. smlouva o zprostředkování zakázek.</p>
        <br />
        <h3>Závěrečná ustanovení:</h3>
        <ol>
            <li>Tato smlouva představuje kompletní dohodu mezi Majitelem a Řidičem ohledně zprostředkování zakázek a platby za provedené služby.</li>
            <li>Veškeré změny této smlouvy musí být učiněny písemně a podepsány oběma stranami.</li>
        </ol>

        <div className="signatures">
        <p>V Chomutově dne : <input type='text' className='niceInput' name='date' value={formData.date} onChange={handleChange} readOnly={alreadySigned ? true : false} /></p>
        <br />
        <br />
        {alreadySigned && <img src={razitko} style={{width: 300}}/> }
        <p>________________________________</p>
        <p>Zaměstanavatel: Vaněček Marek</p>
        
        <br />  <br />
        {!alreadySigned && tokenOfContract && <SignatureColumn sendSignatureToServer={sendSignatureToServer}/> }
        {alreadySigned && <img src={server +'api2/public/signature/' + tokenOfContract + '.png'}/>}
        <p>Zaměstnanec</p>
      </div>
      <div style={{display:'flex' , justifyContent: 'flex-end'}}>
        {!tokenOfContract &&  <input type='text' className='niceInput' placeholder='email' name='email' value={email} onChange={(e) => setEmail(e.target.value)}/> }
        {!tokenOfContract && !loading && <Button variant="success" onClick={handleSubmit}>Odeslat</Button> }
        {!tokenOfContract && loading && <Button variant="secondary">Odesílám <Spinner animation="border" size='sm'/></Button> }
      </div>
    </div>

    )
  }

  export default ContractProvize